var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinRepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.532 8.71053L14.8041 5.26054L12.532 1.81055H11.3541L13.3255 4.76768H7.41127C6.63209 4.76764 5.88437 5.07514 5.33065 5.62333C4.77692 6.17152 4.46193 6.9161 4.45414 7.69525C4.4541 8.0024 4.49893 8.30791 4.58721 8.6021L4.94699 9.69624H5.99185L5.53349 8.33596C5.47033 8.13844 5.43872 7.93219 5.43985 7.72482V7.64596C5.44497 7.39223 5.50004 7.142 5.60189 6.90955C5.70375 6.67711 5.85041 6.46701 6.03348 6.29126C6.21655 6.11551 6.43246 5.97755 6.66887 5.88526C6.90527 5.79297 7.15754 5.74816 7.41127 5.75339H13.3255L11.3541 8.71053H12.532ZM6.72617 10.6819L4.4541 14.1319L6.72617 17.5819H7.90409L5.93267 14.6247L11.8469 14.6247C12.6261 14.6248 13.3738 14.3173 13.9276 13.7691C14.4813 13.2209 14.7963 12.4763 14.8041 11.6972C14.8041 11.39 14.7593 11.0845 14.671 10.7903L14.3112 9.69618H13.2664L13.7247 11.0565C13.7879 11.254 13.8195 11.4602 13.8184 11.6676V11.7465C13.8132 12.0002 13.7582 12.2504 13.6563 12.4829C13.5545 12.7153 13.4078 12.9254 13.2247 13.1012C13.0417 13.2769 12.8258 13.4149 12.5893 13.5072C12.3529 13.5994 12.1007 13.6443 11.8469 13.639H5.93267L7.90409 10.6819H6.72617Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinRepost);
export default __webpack_public_path__ + "static/media/linkedinRepost.a97a4483.svg";
export { ForwardRef as ReactComponent };